/**
 * Use cases API slice.
 * Leaf module (Perf 3.1.b/e Step 6). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 *
 * Powers the public SEO pages at /use-cases and /use-cases/[slug].
 */
import { fetchWithAuth } from './client';

export const useCasesApi = {
  list: async () => fetchWithAuth('/json/use-cases'),

  getBySlug: async (slug) => {
    return fetchWithAuth(`/json/use-cases/${encodeURIComponent(slug)}`);
  },
};
